import getUserId from 'shared_js/helpers/userHelper/getUserId';

function checkPaymentSchemeValid(scheme){
  const userId = getUserId(window);
  if(!scheme.whitelist || scheme.whitelist.length === 0){
    return scheme.active;
  }
  return scheme.whitelist.map(String).includes(String(userId)) && scheme.active;
}

export default checkPaymentSchemeValid;
